import { motion } from 'framer-motion';
import { buttonStyles } from '../lib/buttonStyles';

const Button = ({ children, variant = 'primary', size = 'md', fullWidth = false, className = '', ...props }) => {
    return (
        <motion.button
            whileTap={{ scale: 0.96 }}
            className={buttonStyles({ variant, size, fullWidth, className })}
            {...props}
        >
            {children}
        </motion.button>
    );
};

export default Button;
